import React from 'react';

import Typography from 'components/typography/typography';

import Icon from 'components/icon/icon';

import { createLocale } from 'locales';

const localize = createLocale('freelancerAvailableJobsLocales');

const FilterHeader: React.FC = () => {
  return (
    <div className="flex w-full flex-row items-center  justify-start h-14 text-purple">
      <Icon icon="filter1" className="mx-2 " size={30} />
      <Typography as="h2" variant="page-subheading" className="ml-4">
        {localize('filter')}
      </Typography>
    </div>
  );
};

export default FilterHeader;
